import {Pagination as MuiPagination, PaginationItem, styled} from "@mui/material";

export const Pagination = (props) => {

    return (
        <PaginationComponent {...props} renderItem={itemRender}/>
    )

}

const PaginationComponent = styled(MuiPagination)(({theme}) => ({
    "& .MuiPaginationItem-page": {
        background: theme.palette.secondary.light,
        color: theme.palette.primary.main,
        width: "2.5rem",
        height: "2.5rem",
        borderRadius: 4,
        fontSize: ".85rem",
        fontWeight: 500
    },
    "& .MuiPaginationItem-page.Mui-selected": {
        background: theme.palette.primary.main,
        color: "#fff"
    }
}));

const farsiNumbers = "۰۱۲۳۴۵۶۷۸۹"

function convertNumberToLetter(num) {
    let result = ""
    const str = num.toString();
    for (let c of str) {
        result += farsiNumbers.charAt(c)
    }
    return result
}

function itemRender(item) {
    if (item.type === 'page') {
        item.page = convertNumberToLetter(item.page);
        return (
            <PaginationItem
                {...item}
            />
        )
    }
    return (
        <PaginationItem
            {...item}
        />
    );
}